<script lang="ts">
	import { Router, Route } from "svelte-routing";
	import Credits from "./Credits.svelte";
	import EditForm from "./EditForm.svelte";
	let { url = "" }: { url?: string } = $props();
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	let broadcasterId = urlParams.get("broadcaster_id");
	// only fetch what the current route needs: the user fetch
	// triggers the OAuth login flow on 401, which must never
	// happen on the public credits page
	const onEditPage = window.location.pathname.startsWith("/edit");
	let getCreditsData: Promise<any> | null = onEditPage
		? null
		: fetch("/credits/" + broadcasterId)
				.then((res) => {
					if (!res.ok) {
						throw new Error("Failed to retrieve credits data");
					}
					return res.json();
				})
				.then((data) => {
					return data;
				})
				.catch((err) => {
					console.error(err);
				});
	let getUserData: Promise<any> | null = !onEditPage
		? null
		: fetch("/user/" + broadcasterId)
				.then((res) => {
					if (res.status === 401) {
						// not logged in; bounce through the Twitch OAuth flow,
						// which redirects back to this page with a session cookie
						window.location.href = "/start";
						return new Promise(() => {}); // never resolves; we're navigating away
					}
					if (!res.ok) {
						throw new Error("Failed to retrieve user data");
					}
					return res.json();
				})
				.then((data) => {
					return data;
				})
				.catch((err) => {
					console.error(err);
				});
</script>

<Router {url}>
	<Route path="/">
		<main>
			{#await getCreditsData}
				<p>Loading...</p>
			{:then data}
				<Credits {data} />
			{:catch error}
				<p>Error: {error}</p>
			{/await}
		</main>
	</Route>
	<Route path="/edit">
		{#await getUserData}
			<p>Loading...</p>
		{:then user}
			<EditForm {user} />
		{:catch error}
			<p>Error: {error}</p>
		{/await}
	</Route>
</Router>

<style type="text/css">
	main {
		height: 100%;
		width: 100%;
	}
</style>
